<ng-template #handleView>
  <div class="drag-handle text-muted float-left p-1 mr-2" tabindex="0">
    <i class="fas fa-grip-vertical fa-fw" [title]="'item.edit.bitstreams.edit.buttons.drag' | translate"></i>
  </div>
</ng-template>
